module.exports = __webpack_public_path__ + "static/media/quail-ridge.6cafc821.pdf";